import { render, staticRenderFns } from "./transferRecords.vue?vue&type=template&id=6c36a0a2&scoped=true&"
import script from "./transferRecords.vue?vue&type=script&lang=js&"
export * from "./transferRecords.vue?vue&type=script&lang=js&"
import style0 from "./transferRecords.vue?vue&type=style&index=0&id=6c36a0a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c36a0a2",
  null
  
)

export default component.exports